export default __webpack_public_path__ + "static/media/ea-title-en.81802cd8.webp";